<template>
  <svg
    width="96"
    height="64"
    viewBox="0 0 96 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint0_linear_13_449)"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint1_linear_13_449)"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint2_linear_13_449)"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint3_linear_13_449)"
      fill-opacity="0.13"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint4_linear_13_449)"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint5_linear_13_449)"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint6_radial_13_449)"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint7_radial_13_449)"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint8_radial_13_449)"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint9_linear_13_449)"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint10_linear_13_449)"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint11_linear_13_449)"
      fill-opacity="0.55"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint12_linear_13_449)"
      fill-opacity="0.55"
    />
    <path
      d="M61.2443 7.00759C60.6817 6.44498 59.9187 6.12891 59.123 6.12891H19.3172C16.9976 6.12891 15.1172 8.00931 15.1172 10.3289V85.6711C15.1172 87.9907 16.9976 89.8711 19.3172 89.8711H76.6828C79.0024 89.8711 80.8828 87.9907 80.8828 85.6711V27.8887C80.8828 27.093 80.5667 26.33 80.0041 25.7674L61.2443 7.00759Z"
      fill="url(#paint13_linear_13_449)"
    />
    <path
      d="M56.8662 7.37141C56.8662 6.76721 57.0396 6.25652 56.7108 6.19193C57.0233 6.21184 59.6369 5.9652 59.9182 6.29328C60.2878 6.43843 60.0658 7.0285 60.3552 7.31112C60.3636 7.31936 60.372 7.32765 60.3804 7.33602L79.1401 26.0958C79.1973 26.153 79.2519 26.2123 79.3039 26.2734C79.56 26.5745 79.6919 26.5088 79.8123 26.8806C79.9081 27.1764 80.5954 26.564 80.5954 26.8806L80.826 27.3413V27.9846C80.826 27.9846 80.9702 28.7371 80.5954 28.7371L61.1779 30.9009C58.0947 30.9009 55.1909 27.3568 55.1909 25.3686L56.8662 7.37141Z"
      fill="url(#paint14_linear_13_449)"
    />
    <path
      d="M56.8662 7.37141C56.8662 6.76721 57.0396 6.25652 56.7108 6.19193C57.0233 6.21184 59.6369 5.9652 59.9182 6.29328C60.2878 6.43843 60.0658 7.0285 60.3552 7.31112C60.3636 7.31936 60.372 7.32765 60.3804 7.33602L79.1401 26.0958C79.1973 26.153 79.2519 26.2123 79.3039 26.2734C79.56 26.5745 79.6919 26.5088 79.8123 26.8806C79.9081 27.1764 80.5954 26.564 80.5954 26.8806L80.826 27.3413V27.9846C80.826 27.9846 80.9702 28.7371 80.5954 28.7371L61.1779 30.9009C58.0947 30.9009 55.1909 27.3568 55.1909 25.3686L56.8662 7.37141Z"
      fill="url(#paint15_linear_13_449)"
    />
    <path
      d="M56.8662 7.37141C56.8662 6.76721 57.0396 6.25652 56.7108 6.19193C57.0233 6.21184 59.6369 5.9652 59.9182 6.29328C60.2878 6.43843 60.0658 7.0285 60.3552 7.31112C60.3636 7.31936 60.372 7.32765 60.3804 7.33602L79.1401 26.0958C79.1973 26.153 79.2519 26.2123 79.3039 26.2734C79.56 26.5745 79.6919 26.5088 79.8123 26.8806C79.9081 27.1764 80.5954 26.564 80.5954 26.8806L80.826 27.3413V27.9846C80.826 27.9846 80.9702 28.7371 80.5954 28.7371L61.1779 30.9009C58.0947 30.9009 55.1909 27.3568 55.1909 25.3686L56.8662 7.37141Z"
      fill="url(#paint16_linear_13_449)"
    />
    <path
      d="M60.1174 7.04274C60.1174 6.43854 59.6432 6.19936 59.3145 6.13477C59.6269 6.15468 59.9322 6.22325 60.2197 6.33618C60.5894 6.48134 60.93 6.69983 61.2194 6.98245C61.2278 6.99069 61.2362 6.99898 61.2446 7.00735L80.0043 25.7672C80.0615 25.8243 80.1161 25.8836 80.1682 25.9448C80.4242 26.2458 80.6169 26.5928 80.7372 26.9646C80.833 27.2604 80.883 27.5718 80.883 27.8885V28.0779C80.883 27.3813 80.3791 26.9646 80.0043 26.9646H63.7174C61.7292 26.9646 60.1174 25.3528 60.1174 23.3646V7.04274Z"
      fill="url(#paint17_linear_13_449)"
    />
    <path
      d="M60.1174 7.04274C60.1174 6.43854 59.6432 6.19936 59.3145 6.13477C59.6269 6.15468 59.9322 6.22325 60.2197 6.33618C60.5894 6.48134 60.93 6.69983 61.2194 6.98245C61.2278 6.99069 61.2362 6.99898 61.2446 7.00735L80.0043 25.7672C80.0615 25.8243 80.1161 25.8836 80.1682 25.9448C80.4242 26.2458 80.6169 26.5928 80.7372 26.9646C80.833 27.2604 80.883 27.5718 80.883 27.8885V28.0779C80.883 27.3813 80.3791 26.9646 80.0043 26.9646H63.7174C61.7292 26.9646 60.1174 25.3528 60.1174 23.3646V7.04274Z"
      fill="url(#paint18_linear_13_449)"
    />
    <path
      d="M60.1174 7.04274C60.1174 6.43854 59.6432 6.19936 59.3145 6.13477C59.6269 6.15468 59.9322 6.22325 60.2197 6.33618C60.5894 6.48134 60.93 6.69983 61.2194 6.98245C61.2278 6.99069 61.2362 6.99898 61.2446 7.00735L80.0043 25.7672C80.0615 25.8243 80.1161 25.8836 80.1682 25.9448C80.4242 26.2458 80.6169 26.5928 80.7372 26.9646C80.833 27.2604 80.883 27.5718 80.883 27.8885V28.0779C80.883 27.3813 80.3791 26.9646 80.0043 26.9646H63.7174C61.7292 26.9646 60.1174 25.3528 60.1174 23.3646V7.04274Z"
      fill="url(#paint19_linear_13_449)"
    />
    <path
      d="M60.1174 7.04274C60.1174 6.43854 59.6432 6.19936 59.3145 6.13477C59.6269 6.15468 59.9322 6.22325 60.2197 6.33618C60.5894 6.48134 60.93 6.69983 61.2194 6.98245C61.2278 6.99069 61.2362 6.99898 61.2446 7.00735L80.0043 25.7672C80.0615 25.8243 80.1161 25.8836 80.1682 25.9448C80.4242 26.2458 80.6169 26.5928 80.7372 26.9646C80.833 27.2604 80.883 27.5718 80.883 27.8885V28.0779C80.883 27.3813 80.3791 26.9646 80.0043 26.9646H63.7174C61.7292 26.9646 60.1174 25.3528 60.1174 23.3646V7.04274Z"
      fill="url(#paint20_linear_13_449)"
    />
    <path
      d="M60.1174 7.04274C60.1174 6.43854 59.6432 6.19936 59.3145 6.13477C59.6269 6.15468 59.9322 6.22325 60.2197 6.33618C60.5894 6.48134 60.93 6.69983 61.2194 6.98245C61.2278 6.99069 61.2362 6.99898 61.2446 7.00735L80.0043 25.7672C80.0615 25.8243 80.1161 25.8836 80.1682 25.9448C80.4242 26.2458 80.6169 26.5928 80.7372 26.9646C80.833 27.2604 80.883 27.5718 80.883 27.8885V28.0779C80.883 27.3813 80.3791 26.9646 80.0043 26.9646H63.7174C61.7292 26.9646 60.1174 25.3528 60.1174 23.3646V7.04274Z"
      fill="url(#paint21_radial_13_449)"
    />
    <path
      d="M60.1174 7.04274C60.1174 6.43854 59.6432 6.19936 59.3145 6.13477C59.6269 6.15468 59.9322 6.22325 60.2197 6.33618C60.5894 6.48134 60.93 6.69983 61.2194 6.98245C61.2278 6.99069 61.2362 6.99898 61.2446 7.00735L80.0043 25.7672C80.0615 25.8243 80.1161 25.8836 80.1682 25.9448C80.4242 26.2458 80.6169 26.5928 80.7372 26.9646C80.833 27.2604 80.883 27.5718 80.883 27.8885V28.0779C80.883 27.3813 80.3791 26.9646 80.0043 26.9646H63.7174C61.7292 26.9646 60.1174 25.3528 60.1174 23.3646V7.04274Z"
      fill="url(#paint22_radial_13_449)"
    />
    <path
      d="M60.1174 7.04274C60.1174 6.43854 59.6432 6.19936 59.3145 6.13477C59.6269 6.15468 59.9322 6.22325 60.2197 6.33618C60.5894 6.48134 60.93 6.69983 61.2194 6.98245C61.2278 6.99069 61.2362 6.99898 61.2446 7.00735L80.0043 25.7672C80.0615 25.8243 80.1161 25.8836 80.1682 25.9448C80.4242 26.2458 80.6169 26.5928 80.7372 26.9646C80.833 27.2604 80.883 27.5718 80.883 27.8885V28.0779C80.883 27.3813 80.3791 26.9646 80.0043 26.9646H63.7174C61.7292 26.9646 60.1174 25.3528 60.1174 23.3646V7.04274Z"
      fill="url(#paint23_radial_13_449)"
    />
    <path
      d="M60.1174 7.04274C60.1174 6.43854 59.6432 6.19936 59.3145 6.13477C59.6269 6.15468 59.9322 6.22325 60.2197 6.33618C60.5894 6.48134 60.93 6.69983 61.2194 6.98245C61.2278 6.99069 61.2362 6.99898 61.2446 7.00735L80.0043 25.7672C80.0615 25.8243 80.1161 25.8836 80.1682 25.9448C80.4242 26.2458 80.6169 26.5928 80.7372 26.9646C80.833 27.2604 80.883 27.5718 80.883 27.8885V28.0779C80.883 27.3813 80.3791 26.9646 80.0043 26.9646H63.7174C61.7292 26.9646 60.1174 25.3528 60.1174 23.3646V7.04274Z"
      fill="url(#paint24_radial_13_449)"
    />
    <path
      d="M60.1174 7.04274C60.1174 6.43854 59.6432 6.19936 59.3145 6.13477C59.6269 6.15468 59.9322 6.22325 60.2197 6.33618C60.5894 6.48134 60.93 6.69983 61.2194 6.98245C61.2278 6.99069 61.2362 6.99898 61.2446 7.00735L80.0043 25.7672C80.0615 25.8243 80.1161 25.8836 80.1682 25.9448C80.4242 26.2458 80.6169 26.5928 80.7372 26.9646C80.833 27.2604 80.883 27.5718 80.883 27.8885V28.0779C80.883 27.3813 80.3791 26.9646 80.0043 26.9646H63.7174C61.7292 26.9646 60.1174 25.3528 60.1174 23.3646V7.04274Z"
      fill="url(#paint25_radial_13_449)"
    />
    <path
      d="M52.582 62.9883C53.404 62.9883 54.0703 63.6546 54.0703 64.4766C54.0703 65.2985 53.404 65.9648 52.582 65.9648H28.6055C27.7835 65.9648 27.1172 65.2985 27.1172 64.4766C27.1172 63.6546 27.7835 62.9883 28.6055 62.9883H52.582ZM67.3711 53.9883C68.193 53.9883 68.8594 54.6546 68.8594 55.4766C68.8594 56.2985 68.193 56.9648 67.3711 56.9648H28.6055C27.7835 56.9648 27.1172 56.2985 27.1172 55.4766C27.1172 54.6546 27.7835 53.9883 28.6055 53.9883H67.3711ZM67.3711 44.9883C68.193 44.9883 68.8594 45.6546 68.8594 46.4766C68.8594 47.2985 68.193 47.9648 67.3711 47.9648H28.6055C27.7835 47.9648 27.1172 47.2985 27.1172 46.4766C27.1172 45.6546 27.7835 44.9883 28.6055 44.9883H67.3711ZM67.3711 35.9883C68.193 35.9883 68.8594 36.6546 68.8594 37.4766C68.8594 38.2985 68.193 38.9648 67.3711 38.9648H28.6055C27.7835 38.9648 27.1172 38.2985 27.1172 37.4766C27.1172 36.6546 27.7835 35.9883 28.6055 35.9883H67.3711Z"
      fill="url(#paint26_linear_13_449)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_13_449"
        x1="48"
        y1="6.12891"
        x2="48"
        y2="89.8711"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EBE4F3" />
        <stop
          offset="1"
          stop-color="#E4DAF0"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_13_449"
        x1="48"
        y1="6.50941"
        x2="48"
        y2="7.21009"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3F0F6" />
        <stop
          offset="1"
          stop-color="#F3F0F6"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_13_449"
        x1="80.8828"
        y1="45.9241"
        x2="79.8561"
        y2="45.9241"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3F0F6" />
        <stop
          offset="1"
          stop-color="#F3F0F6"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_13_449"
        x1="81.5691"
        y1="45.9241"
        x2="80.3616"
        y2="45.9241"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop
          offset="1"
          stop-color="#B9A6CC"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_13_449"
        x1="12.6601"
        y1="45.9241"
        x2="15.6617"
        y2="45.9296"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop
          offset="1"
          stop-color="#B5B0BB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_13_449"
        x1="52.5573"
        y1="91.4666"
        x2="52.5573"
        y2="89.31"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop
          offset="1"
          stop-color="#B5B0BB"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint6_radial_13_449"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.8613 90.4246) rotate(-72.992) scale(1.55745 5.05531)"
      >
        <stop stop-color="#B5B0BB" />
        <stop
          offset="1"
          stop-color="#B5B0BB"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint7_radial_13_449"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.5297 89.2682) rotate(-60.2552) scale(1.41263 4.58525)"
      >
        <stop stop-color="#B5B0BB" />
        <stop
          offset="1"
          stop-color="#B5B0BB"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint8_radial_13_449"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.0041 87.7438) rotate(-38.6597) scale(1.00973 3.27749)"
      >
        <stop stop-color="#B5B0BB" />
        <stop
          offset="1"
          stop-color="#B5B0BB"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint9_linear_13_449"
        x1="13.7643"
        y1="85.724"
        x2="15.8604"
        y2="85.724"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop
          offset="1"
          stop-color="#B5B0BB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint10_linear_13_449"
        x1="12.8158"
        y1="6.93549"
        x2="16.7314"
        y2="8.63655"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop
          offset="1"
          stop-color="#B5B0BB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint11_linear_13_449"
        x1="13.5076"
        y1="44.7753"
        x2="16.5368"
        y2="44.7753"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop
          offset="1"
          stop-color="#B9A6CC"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint12_linear_13_449"
        x1="48"
        y1="89.8711"
        x2="48"
        y2="89.1585"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop
          offset="1"
          stop-color="#B9A6CC"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint13_linear_13_449"
        x1="79.2308"
        y1="89.3546"
        x2="78.7969"
        y2="88.5469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop
          offset="1"
          stop-color="#B9A6CC"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint14_linear_13_449"
        x1="63.9142"
        y1="14.8027"
        x2="58.7646"
        y2="14.8027"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.72"
          stop-color="#D2C5DE"
        />
        <stop
          offset="1"
          stop-color="#D2C5DF"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint15_linear_13_449"
        x1="71.1741"
        y1="33.6812"
        x2="71.1372"
        y2="26.8858"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.72"
          stop-color="#E9E1F3"
        />
        <stop
          offset="1"
          stop-color="#E9E1F3"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint16_linear_13_449"
        x1="61.4523"
        y1="24.7864"
        x2="56.3642"
        y2="32.759"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#E9E1F3"
          stop-opacity="0"
        />
        <stop
          offset="0.682292"
          stop-color="#E9E1F3"
        />
      </linearGradient>
      <linearGradient
        id="paint17_linear_13_449"
        x1="61.6174"
        y1="26.1209"
        x2="69.5392"
        y2="18.199"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D9D3E1" />
        <stop
          offset="1"
          stop-color="#CCC7D1"
        />
      </linearGradient>
      <linearGradient
        id="paint18_linear_13_449"
        x1="71.3205"
        y1="16.6521"
        x2="69.3986"
        y2="18.5271"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.119171"
          stop-color="#DBDADC"
        />
        <stop
          offset="0.577307"
          stop-color="#CBC7D0"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint19_linear_13_449"
        x1="60.0471"
        y1="14.2449"
        x2="60.4902"
        y2="14.2449"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A19CA7" />
        <stop
          offset="1"
          stop-color="#9D9CA7"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint20_linear_13_449"
        x1="70.0987"
        y1="27.1053"
        x2="70.0987"
        y2="26.4959"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C0ACD5" />
        <stop
          offset="1"
          stop-color="#C0ACD5"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint21_radial_13_449"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(62.6542 27.2943) rotate(-81.1582) scale(1.10947 6.4247)"
      >
        <stop stop-color="#C0ACD5" />
        <stop
          offset="1"
          stop-color="#C0ACD5"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint22_radial_13_449"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(60.9732 26.466) rotate(-40.8602) scale(1.02525 5.93702)"
      >
        <stop stop-color="#A19CA7" />
        <stop
          offset="1"
          stop-color="#A19CA7"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint23_radial_13_449"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(60.1021 25.513) rotate(-24.7752) scale(1.01035 5.8507)"
      >
        <stop stop-color="#A19CA7" />
        <stop
          offset="1"
          stop-color="#A19CA7"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint24_radial_13_449"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.5135 24.4711) rotate(-6.45541) scale(1.26653 7.33417)"
      >
        <stop stop-color="#A19CA7" />
        <stop
          offset="1"
          stop-color="#A19CA7"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint25_radial_13_449"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(61.3998 26.6576) rotate(-59.8587) scale(0.826449 4.78578)"
      >
        <stop stop-color="#A19CA7" />
        <stop
          offset="1"
          stop-color="#A19CA7"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint26_linear_13_449"
        x1="27.1172"
        y1="64.4766"
        x2="54.0703"
        y2="64.4766"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9C96A2" />
        <stop
          offset="1"
          stop-color="#9A95A1"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
